import AtzelsApproach from "assets/images/zones/AtzelsApproach/AtzelsApproach.jpg";
import CoastOfArdashir from "assets/images/zones/CoastOfArdashir/CoastOfArdashir.jpg";
import ChosainProvince from "assets/images/zones/ChosainProvince/ChosainProvince.jpg";
import TarantiaCommonDistrict from "assets/images/zones/TarantiaCommonDistrict/TarantiaCommonDistrict.jpg";
import ConallsValley from "assets/images/zones/ConallsValley/ConallsValley.jpg";
import EiglophianMountains from "assets/images/zones/EiglophianMountains/EiglophianMountains.jpg";
import FieldOfTheDead from "assets/images/zones/FieldOfTheDead/FieldOfTheDead.jpg";
import GatewayToKhitai from "assets/images/zones/GatewayToKhitai/GatewayToKhitai.jpg";
import KaraKorum from "assets/images/zones/KaraKorum/KaraKorum.jpg";
import Kheshatta from "assets/images/zones/Kheshatta/Kheshatta.jpg";
import KhopshefProvince from "assets/images/zones/KhopshefProvince/KhopshefProvince.jpg";
import TarantiaNobleDistrict from "assets/images/zones/TarantiaNobleDistrict/TarantiaNobleDistrict.jpg";
import NorthernGrasslands from "assets/images/zones/NorthernGrasslands/NorthernGrasslands.jpg";
import Paikang from "assets/images/zones/Paikang/Paikang.jpg";
import WhiteSands from "assets/images/zones/WhiteSands/WhiteSands.jpg";
import WildLandsOfZelata from "assets/images/zones/WildLandsOfZelata/WildLandsOfZelata.jpg";
import ThunderRiver from "assets/images/zones/ThunderRiver/ThunderRiver.jpg";
import YmirsPass from "assets/images/zones/YmirsPass/YmirsPass.jpg";
import DragonsSpine from "assets/images/zones/DragonsSpine/DragonsSpine.jpg";
import BorderRange from "assets/images/zones/BorderRange/BorderRangeMap.jpg";
import BorderKingdomsAquilonianEnd from "assets/images/zones/BorderKingdomsAquilonianEnd/BorderKingdomsAquilonianEnd.jpg";
import BorderKingdomsCimmerianEnd from "assets/images/zones/BorderKingdomsCimmerianEnd/BorderKingdomsCimmerianEnd.jpg";
import BorderToKush from "assets/images/zones/BorderToKush/BorderToKush.jpg";

export const ZoneIcons: any = {
  1080: AtzelsApproach,
  7000: CoastOfArdashir,
  6300: ChosainProvince,
  2020: TarantiaCommonDistrict,
  1010: ConallsValley,
  1050: EiglophianMountains,
  1020: FieldOfTheDead,
  6001: GatewayToKhitai,
  3030: Kheshatta,
  3020: KhopshefProvince,
  3071: DragonsSpine,
  6200: KaraKorum,
  6400: Paikang,
  2010: TarantiaNobleDistrict,
  6100: NorthernGrasslands,
  10800: WhiteSands,
  2080: WildLandsOfZelata,
  2090: ThunderRiver,
  1090: YmirsPass,
  2084: BorderRange,
  12070: BorderKingdomsAquilonianEnd,
  13050: BorderToKush,
  11040: BorderKingdomsCimmerianEnd
}